// hooks/Planpage/usePromoCode.js
import { useState } from 'react';

const VALID_PROMO_CODES = ['HEALTH50'];

export const usePromoCode = () => {
  const [promoCode, setPromoCode] = useState('');
  const [promoApplied, setPromoApplied] = useState(false);
  const [showPromoModal, setShowPromoModal] = useState(false);

  const applyPromo = () => {
    if (VALID_PROMO_CODES.includes(promoCode.trim())) {
      setPromoApplied(true);
      return true;
    }
    alert('Invalid promo code');
    return false;
  };

  const resetPromo = () => {
    setPromoCode('');
    setPromoApplied(false);
  };

  return {
    promoCode,
    setPromoCode,
    promoApplied,
    showPromoModal,
    setShowPromoModal,
    applyPromo,
    resetPromo
  };
};